var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuMoreProfile = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5,11.23c1.41,0,2.74-.55,3.75-1.55,1-1,1.55-2.33,1.55-3.75s-.55-2.74-1.55-3.75c-1-1-2.33-1.55-3.75-1.55s-2.74,.55-3.75,1.55c-1,1-1.55,2.33-1.55,3.75s.55,2.74,1.55,3.75c1,1,2.33,1.55,3.75,1.55Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.97,13.04c-.91-1.19-2.23-2-3.9-2.42-.13-.03-.27,0-.37,.09-1.16,1.02-2.65,1.59-4.2,1.59s-3.03-.56-4.2-1.59c-.1-.09-.24-.12-.37-.09-1.67,.42-2.98,1.23-3.9,2.42-1.03,1.33-1.55,3.13-1.55,5.35,0,.18,.11,.33,.27,.39,2.59,1.02,6.05,1.59,9.74,1.59s7.14-.56,9.74-1.59c.16-.06,.28-.21,.28-.39,0-2.22-.52-4.02-1.55-5.35Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuMoreProfile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_More_Profile.80b14dc0.svg";
export { ForwardRef as ReactComponent };